module.exports = __webpack_public_path__ + "static/media/dps1.png.ea01b23c.jpg";